import type {
	FilterOrFilterGroupConfig,
	FiltersConfig,
} from "hsl-core/FundExplorer";

export default function getFilterSubset(
	filters: FiltersConfig["filters"],
	{ include = [], exclude = [] }: { include?: string[]; exclude?: string[] },
) {
	const getSubsetRecursive = (
		filters: FilterOrFilterGroupConfig[],
	): FilterOrFilterGroupConfig[] => {
		return filters.reduce((subset, f) => {
			const newFilter = { ...f };
			if (f.type === "group") {
				newFilter.filters = getSubsetRecursive(f.filters);
			}
			const keep =
				(include.length > 0 && include.includes(f.key)) ||
				(exclude.length > 0 && !exclude.includes(f.key));
			if (!keep) return subset;
			subset.push(newFilter);
			return subset;
		}, [] as FilterOrFilterGroupConfig[]);
	};

	return getSubsetRecursive(filters);
}
